import { APP_CONSTANTS, I18n } from '~/common/explicit-exports';
import { CONTENT_PROVIDER_INTEGRATION_FIELDS } from '../../../constants';

const INTEGRATIONS = APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES;

type IntegrationSlug = (typeof INTEGRATIONS)[keyof typeof INTEGRATIONS];
type SettingsField = {
  key: string;
  fieldProps?: {
    adornment?: string;
  };
};
type SettingsConfig = {
  [key in IntegrationSlug]?: {
    description: string;
    documentationLink: string;
    fields: SettingsField[];
  };
};

type ContentProviderAdminSettings = {
  description: string;
  documentationLink: string;
  fields: SettingsField[];
};

export const getContentProviderAdminSettings = (slug: string): ContentProviderAdminSettings => {
  const settingsConfig: SettingsConfig = {
    [INTEGRATIONS.LINKEDIN_LEARNING]: {
      description: I18n.t('js.admin.integration_settings.linkedin_learning.description'),
      documentationLink: 'http://help.workramp.com/en/articles/10083248',
      fields: [
        { key: CONTENT_PROVIDER_INTEGRATION_FIELDS.CLIENT_ID },
        { key: CONTENT_PROVIDER_INTEGRATION_FIELDS.CLIENT_SECRET },
      ],
    },
    [INTEGRATIONS.UDEMY]: {
      description: I18n.t('js.admin.integration_settings.udemy.description'),
      documentationLink: 'https://help.workramp.com/en/articles/10074102-employee-learning-cloud-udemy-integration',
      fields: [
        { key: CONTENT_PROVIDER_INTEGRATION_FIELDS.CLIENT_ID },
        { key: CONTENT_PROVIDER_INTEGRATION_FIELDS.CLIENT_SECRET },
        {
          key: CONTENT_PROVIDER_INTEGRATION_FIELDS.CONTENT_PROVIDER_SUBDOMAIN,
          fieldProps: {
            adornment: '.udemy.com',
          },
        },
      ],
    },
  };

  try {
    if (!settingsConfig[slug]) {
      throw new Error(`Invalid content provider slug: ${slug}`);
    }
  } catch (error) {
    console.error(error);
    return {
      description: '',
      documentationLink: '',
      fields: [],
    };
  }

  return settingsConfig[slug] as ContentProviderAdminSettings;
};
